import {
  DiscountApplicationMethodEnum,
  DiscountDurationEnum,
  DiscountStatusEnum,
} from '@monetize/types/app';
import { objectToSelectOptions } from '../utils/misc';

export const DISCOUNT_STATUS = [
  { name: 'Active', value: 'ACTIVE' },
  { name: 'Inactive', value: 'INACTIVE' },
  { name: 'Pending', value: 'PENDING' },
  { name: 'Expired', value: 'EXPIRED' },
];

export const DISCOUNT_STATUS_ENUM_DISPLAY: {
  [key in DiscountStatusEnum]: string;
} = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  PENDING: 'Pending',
  EXPIRED: 'Expired',
};

export const DISCOUNT_APPLY_ON = [
  // { name: 'Total Amount', value: 'Total Amount' },
  { name: 'Invoice', value: 'Invoice' },
  { name: 'Invoice Lines', value: 'Invoice Lines' },
];

export const DISCOUNT_DURATION_DISPLAY_TEXT: {
  [key in DiscountDurationEnum]: string;
} = {
  LIMITED: 'Limited',
  UNLIMITED: 'Unlimited',
  ONE_TIME: 'Onetime',
};

export const DISCOUNT_DURATION_TYPES = objectToSelectOptions(
  DISCOUNT_DURATION_DISPLAY_TEXT,
);

export const DISCOUNT_APPLICATION_METHOD_DISPLAY_TEXT: {
  [key in DiscountApplicationMethodEnum]: string;
} = {
  COMBINED: 'Combined',
  SEQUENTIAL: 'Sequential',
};

export const DISCOUNT_APPLICATION_METHOD_OPTIONS = objectToSelectOptions(
  DISCOUNT_APPLICATION_METHOD_DISPLAY_TEXT,
);
